import React, {Component} from 'react';

const campaignLink = 'https://hemelslinn.s.gy/vh-web-hem-land';

class LandingSections extends Component {
    render() {
        return (
            <>
                <section id="cos-e" className="landing-section landing-section-dark">
                    <div className="container">
                        <div className="landing-kicker">Cos'è Verso Hemelslinn</div>
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <h2>Una galassia immensa. Nessun alieno. Solo l’umanità davanti alle proprie scelte.</h2>
                            </div>
                            <div className="col-lg-6">
                                <p>Verso Hemelslinn racconta una galassia immensa, una missione segreta e un equipaggio piccolo abbastanza da sentire il peso di ogni scelta.</p>
                                <p>Non ci sono civiltà extraterrestri a spiegare il mistero. Al centro restano gli esseri umani: ciò che desiderano, ciò che temono, ciò che sono disposti a rischiare quando la rotta cambia per sempre.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="diverso" className="landing-section landing-section-light">
                    <div className="container">
                        <div className="landing-kicker">Perché è diverso</div>
                        <h2>La meraviglia dello spazio, con il cuore vicino.</h2>
                        <div className="landing-grid">
                            <article>
                                <h3>Zero alieni</h3>
                                <p>Nessun nemico facile venuto da fuori. Solo l'umanità davanti all'infinito e alle proprie responsabilità.</p>
                            </article>
                            <article>
                                <h3>Amore come motore</h3>
                                <p>Il sentimento non interrompe l'avventura: le dà direzione, conseguenze e una posta in gioco più intima.</p>
                            </article>
                            <article>
                                <h3>Una galassia contesa</h3>
                                <p>In Galàxias viaggiare tra le stelle è un privilegio controllato da pochi. La libertà ha bisogno di qualcuno che osi cambiare le regole.</p>
                            </article>
                        </div>
                    </div>
                </section>

                <section id="per-chi" className="landing-section landing-section-dark">
                    <div className="container">
                        <div className="landing-kicker">Per chi è</div>
                        <h2>Per chi cerca fantascienza epica, ma non fredda.</h2>
                        <div className="landing-list">
                            <p>Per chi ama navi, rotte impossibili, scoperte e pericoli cosmici.</p>
                            <p>Per chi vuole personaggi che scelgono, sbagliano, restano, si fidano.</p>
                            <p>Per chi crede che una storia d'amore possa reggere il peso di una galassia.</p>
                        </div>
                    </div>
                </section>

                <section id="campaign" className="landing-section landing-section-light">
                    <div className="container">
                        <div className="landing-kicker">Cosa ricevi sostenendo la campagna</div>
                        <h2>Non compri solo un libro. Aiuti una storia a nascere.</h2>
                        <div className="landing-grid landing-grid-four">
                            <article>
                                <h3>Il romanzo</h3>
                                <p>Ricompense legate alle edizioni cartonata e digitale di Verso Hemelslinn.</p>
                            </article>
                            <article>
                                <h3>Anteprime</h3>
                                <p>Accesso anticipato a materiali, aggiornamenti e contenuti dal viaggio della Delphís.</p>
                            </article>
                            <article>
                                <h3>Bonus</h3>
                                <p>Contenuti extra audio-video e materiali pensati per chi sale a bordo dall'inizio.</p>
                            </article>
                            <article>
                                <h3>Appartenenza</h3>
                                <p>Diventi parte del primo equipaggio di lettori che sostiene una space opera italiana dal basso.</p>
                            </article>
                        </div>
                        <div className="landing-cta-inline">
                            <a href={campaignLink} className="btn btn-info py-3 px-4" target="_blank" rel="noreferrer noopener">Scegli la tua ricompensa</a>
                        </div>
                    </div>
                </section>

                <section id="faq" className="landing-section landing-section-dark">
                    <div className="container">
                        <div className="landing-kicker">Domande frequenti</div>
                        <h2>Prima di salire a bordo.</h2>
                        <div className="faq-list">
                            <details>
                                <summary>Devo amare la fantascienza per leggerlo?</summary>
                                <p>No. C'è tecnologia, avventura e senso del meraviglioso, ma il cuore della storia sono relazioni, scelte morali e desiderio di libertà.</p>
                            </details>
                            <details>
                                <summary>Ci sono alieni?</summary>
                                <p>No. È una scelta precisa: togliere gli alieni per lasciare l'umanità sola davanti alle stelle.</p>
                            </details>
                            <details>
                                <summary>La parte romantica è solo una sottotrama?</summary>
                                <p>No. L'amore cambia il senso del viaggio e rende più personale ciò che è in gioco.</p>
                            </details>
                            <details>
                                <summary>Perché sostenere ora?</summary>
                                <p>Perché ora puoi aiutare il progetto a trovare i suoi primi lettori e far nascere il libro con una comunità reale attorno.</p>
                            </details>
                        </div>
                    </div>
                </section>

                <section id="cta-finale" className="landing-final-cta">
                    <div className="container">
                        <p className="landing-kicker">Sali a bordo</p>
                        <h2>La Delphís sta cercando il suo primo equipaggio.</h2>
                        <p>Se una space opera romantica, umana e senza alieni ti chiama, questo è il momento di entrare nella rotta.</p>
                        <a href={campaignLink} className="btn btn-info py-3 px-4" target="_blank" rel="noreferrer noopener">Unisciti all'equipaggio</a>
                    </div>
                </section>
            </>
        );
    }
}

export default LandingSections;
